@import '../../../../../constants/spacing.module.less';

.get-rewarded-modal {
  align-items: flex-start;
}

.image {
  height: 378px;
  align-self: center;
}
